const OnVisitUserDetails = function() {
  const user_ids = this.collection.selected_rows
  alert(`It will redirec to ${user_ids.join(",")}`)
}
export default OnVisitUserDetails